/**
 * 笑话页面数据管理
 */
import api from '../../api/api'
import * as types from '../mutation'
import { getNowTime } from '../../utils/com'

const state = {
    jokedata: {},
    joketotalItem : 0,
    jokeItemUrlList :[],
    interlude:[],
    interludeUrl:null,
    currentIndex:null,
    autoplay:false,
}

const getters = {
    jokeData : state =>state.jokedata,
    jokeTotalItem : state => state.joketotalItem,
    jokeItemUrlList : state => state.jokeItemUrlList,
    interlude :state => state.interlude,
    interludeUrl :state => state.interludeUrl,
    currentIndex :state => state.currentIndex,
    autoplay :state => state.autoplay,
}

const mutations = {
    [types.GET_JOKE_LIST_DEFAULT] (state, { response }) {
        let _data = {}
        let jokesList = []
        if(response && response.code === 0){
          _data = response.data.joke
          if(_data){
            for(let v of _data){
                let t = v.tags;
                let t_1 = t.split('#').join(' / ');
                v.tags = t_1;
                jokesList.push(v.url)
            }
            state.joketotalItem = Number(response.data.total)
          }  
        }
        state.jokedata = _data
        state.jokeItemUrlList = jokesList
        // _data.maintainProportions = Number(_data.maintainProportions)
    },

    [types.GET_INTERLUDE_LIST] (state, { response }) {
        let _data = {}
        if(response && response.code === 0){
            _data = response.data.interlude
        }
        state.interlude = _data
    },

    [types.SET_INTERLUDE_URL] (state, url) {
          state.interludeUrl = url
          console.log(state.interludeUrl)
    },

    [types.SET_CURRENT_INDEX] (state, index) {
        state.currentIndex = index
    },

    [types.SET_AUTOPLAY] (state, boolean) {
        state.autoplay = boolean
    }
}

const actions = {
    //获取笑话列表
    getJokeList ({ commit, state, rootState }, param) {
        console.debug("getJokeList> param:%o", param);
        commit(types.GET_JOKE_LIST_DEFAULT, {})

        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/joke/list',
            param,
            (response) => {
                console.debug("getJokeList ok response:%o", response);
                commit(types.GET_JOKE_LIST_DEFAULT, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getJokeList err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });

    },

    //获取过场音效列表
    getInterludeList ({ commit, state, rootState }, param) {
        console.debug("getInterludeList> param:%o", param);
        commit(types.GET_INTERLUDE_LIST, {})

        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/interlude/list',
            param,
            (response) => {
                console.debug("getInterludeList ok response:%o", response);
                commit(types.GET_INTERLUDE_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getInterludeList err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });

    },

    //设置选中过场音乐url
    setInterludeUrl ({ commit, state, rootState }, url) {
        console.debug("setInterludeList> url:%o", url);
        commit(types.SET_INTERLUDE_URL, url)
    },

    //设置当前播放音频的index
    setCurrentIndex ({ commit, state, rootState }, index) {
        console.debug("setcurrentIndex> index:%o", index);
        commit(types.SET_CURRENT_INDEX, index)
    },

    //设置自动播放
    setAutoPlay ({ commit, state, rootState }, boolean) {
        console.debug("setAutoPlay> autoplay:%o", boolean);
        commit(types.SET_AUTOPLAY, boolean)
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/joke.js